import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Navbar } from '../navbar/navbar';
import { Footer } from '../footer/footer';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-inperson-success',
  standalone: true,
  imports: [CommonModule, Navbar, Footer, RouterLink],
  template: `
    <app-navbar></app-navbar>
    <div class="success-page">
      <div class="center-wrap">
        <div class="card">
          <div class="header">
           
            <div class="heading">  <span class="badge ">✓</span>Your In-Person Appointment Request<br />Was Submitted</div>
          </div>
          <div class="content-text ">
            Thank you for your interest in scheduling an in-person psychiatric appointment. Our administrative team will
            contact you soon to confirm the details.
            <br />
            In the meantime, feel free to <a href="https://animosanopsychiatry.com" target="_blank" style="color: rgb(35, 103, 185); text-decoration: underline; font-weight: 600;">Explore our Website</a> to learn more about our services and providers.
          </div>
          <div class="actions">
            <a class="btn outline" href="tel:+19193917202">Call Us</a>
            <a class="btn solid" [routerLink]="['/scheduler']">Book a Telehealth Appointment</a>
          </div>
        </div>
      </div>
      <app-footer></app-footer>
    </div>
  `,
  styles: [`
    @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;600&display=swap');
    .success-page { min-height: 100vh; background: rgb(239, 248, 255); display: flex; flex-direction: column; }
    .center-wrap { flex: 1; display: flex; align-items: center; justify-content: center; padding: 24px 16px; }
    .card { background: #fff; border-radius: 1px; box-shadow: 0 12px 30px rgba(0,0,0,0.12); padding: 32px 28px; max-width: 880px; width: 100%; text-align: center; }
    .header { display: flex; justify-content: center; gap: 12px; margin-bottom: 12px; }
    .badge { display: inline-flex; align-items: center; justify-content: center; width: 28px; height: 28px; border-radius: 50%; background: #22c55e; color: white; font-weight: 700;   margin-right: 8px;}
    .heading { font-family: arial, Arial, sans-serif; font-weight: 600; font-size: 26px; line-height: 150%; color: rgb(35, 103, 185); }
    .content-text { font-family: arial, Arial, sans-serif; font-weight: 400; font-size: 20px; line-height: 150%; color: #414141; width: 80%; margin: 14px auto 22px; }
    .actions { display: flex; gap: 12px; justify-content: center; flex-wrap: wrap; }
    .btn { display: inline-flex; align-items: center; justify-content: center; border-radius: 28px; padding: 12px 22px; font-weight: 700; text-decoration: none; min-width: 180px; }
    .btn.solid { background: rgb(35, 103, 185); color: #fff; }
    .btn.outline { background: #57D6FA; color: #235894; }
    @media (max-width: 600px) { .heading { font-size: 24px; } .content-text { font-size: 16px; width: 95%; } .btn { min-width: 150px; padding: 10px 18px; } }
  `]
})
export class InPersonSuccess {}


